<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp
      :search-show="true"
      @onSearch="attachData"
      @onReset="onResetParams"
    >
      <template>
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Thông tin khách</div>
                  <input type="text" />
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <div class="flex gap-10">
                    <CalendarSelect
                      v-model="searchParams.dateFrom"
                      style="width: 100%"
                      mode="date"
                    />
                    <CalendarSelect
                      v-model="searchParams.dateTo"
                      style="width: 100%"
                      mode="date"
                    />
                    <!-- <MultiCalendar
                      class="use-icon"
                      :from-date="searchParams.dateFrom"
                      :to-date="searchParams.dateTo"
                    /> -->
                  </div>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="checkbox-container">
                    <!-- <div class="checkbox-wrap">
                      <input id="cpSpdTp2" type="checkbox" />
                      <label for="cpSpdTp2">Hiển thị hết</label>
                    </div> -->
                    <div class="checkbox-wrap">
                      <input
                        id="cpSpdTp3"
                        v-model="searchParams.includingPayment"
                        type="checkbox"
                      />
                      <label for="cpSpdTp3">Bao gồm thanh toán</label>
                    </div>
                    <div class="checkbox-wrap">
                      <input
                        id="cpSpdTp4"
                        v-model="searchParams.surplus"
                        type="checkbox"
                      />
                      <label for="cpSpdTp4">Hiển thị có số dư</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
      />
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small" @click="downloadExcel">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <el-dialog
      :title="isEdit ? $t('dialog.titleTaxUpdate') : $t('dialog.titleTaxAdd')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <!-- <el-form :model="form">
        <el-form-item label="Mã*">
          <el-input v-model="taxItem.code" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mức thuế(%)*">
          <el-input v-model="taxItem.level" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Mô tả*">
          <el-input v-model="taxItem.desc" placeholder="Nhập thông tin" />
        </el-form-item>
        <el-form-item label="Thứ tự">
          <el-input v-model="taxItem.order" placeholder="Nhập thông tin" />
        </el-form-item>
      </el-form> -->
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  :name="$t('validator.code')"
                >
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.code') }}:</div>
                    <div class="child-w-80">
                      <input
                        v-model="taxItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|integer|percent"
                  name="Mức thuế"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.taxLevel') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="taxItem.level"
                        v-numeric-only
                        type="text"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 255" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('dialog.desc') }}:</div>
                    <div class="child-w-80">
                      <textarea v-model="taxItem.desc" rows="4" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateTax"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addTax">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { downloadFile } from '@/utils/file-handler'
import {
  addTaxApi,
  updateTaxApi,
  deleteTaxApi
} from '@/api/configuration/accounting/tax.js'
import {
  getListStatement,
  downloadStatementList
} from '@/api/accounting/statement'
export default {
  data() {
    return {
      loading: false,
      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        // },
        {
          headerName: this.$t('grid.column.accountNum'),
          field: 'debt_account_number',
          tooltipField: 'debt_account_number',
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.debtAccountName'),
          field: 'debt_account_name',
          tooltipField: 'debt_account_name',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.address'),
          tooltipField: 'address',
          field: 'address',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.invoiceNumber'),
          field: 'invoice_num',
          tooltipField: 'invoice_num',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.initMoney'),
          field: 'money',
          valueGetter: param => {
            if (param?.data?.money) {
              return this.$displayCurrency(param.data.money)
            } else {
              return 0
            }
          },
          tooltipValueGetter: param => {
            if (param?.data?.money) {
              return this.$displayCurrency(param.data.money)
            } else {
              return 0
            }
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.surplus'),
          field: 'surplus',
          maxWidth: 200,
          valueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return 0
            }
          },
          tooltipValueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return 0
            }
          }
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note',
          minWidth: 300,
          flex: 1
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        dateFrom: null,
        dateTo: null,
        includingPayment: false,
        surplus: false
      },
      taxItem: {
        code: null,
        level: null,
        desc: '',
        order: 1
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    async downloadExcel() {
      bus.$emit('startLoader', { msg: '' })
      await downloadStatementList(this.searchParams)
        .then(res => {
          downloadFile(res, 'Danh sách bảng kê công nợ.xlsx')
          this.$message({
            type: 'success',
            message: this.$t('successMsg.downloadSuccessful')
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.downloadError')
          })
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    onResetParams() {
      this.searchParams = {
        dateFrom: null,
        dateTo: null,
        includingPayment: false,
        surplus: false
      }
      this.attachData()
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.$nullValueInObj(this.taxItem)
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addTax() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addTaxApi(this.taxItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editTax() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.taxItem, row)
    },
    async deleteTax() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá loại thuế này?', () => {
          deleteTaxApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async updateTax() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateTaxApi(this.taxItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListStatement(this.searchParams)
      this.loading = false
      this.rows = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
